import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Col, Form, FormCheck, Row, Spinner } from "react-bootstrap";
import { useHistory, withRouter, useLocation } from "react-router-dom"; // Import useLocation
import { Texterror } from "../../../constants/Texterror";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { profileform } from "../../../constants/Validation";
import {
  getProfile,
  getProfileSession,
  profilesaveSession,
  removeProfile,
  updateProfile,
} from "../../../redux/actions/dbactions/profileActions";
import {
  editUser
} from "../../../redux/actions/dbactions/usersActions";
import {
  citylist,
  refTypesList,
} from "../../../redux/actions/dbactions/refactions";
import { getSession } from "../../../redux/actions/authActions";
import "./style.scss"; // Import your custom CSS file
import { Header } from "../../Header";
import ProfileIcon from "../../../../assets/ProfileIcon";
import { toast } from "react-toastify";

const UserProfile = ({ roleID }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Define loading state
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation(); // Use location here
  const { refsdata } = useSelector((state) => state.refstypes);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const { user_profile_id } = getSession();
  const { profileData } = getProfileSession();
  const [refresh, setRefresh] = useState(false);
  const [saved, setSaved] = useState(false);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );

  // Extract user data from location state
  const userData = location.state?.userData;

  useEffect(() => {
    dispatch(getProfile());
    dispatch(refTypesList());
  }, [dispatch]);

  useEffect(() => {
    if (refresh) {
      dispatch(getProfile());
      setRefresh(false);
    }
  }, [refresh, dispatch]);

  const countryname = refsdata.usr?.iso_cntry || [];
  const titlename = refsdata.usr?.user_title || [];
  const citiesName = citis.usr?.iso_city || [];

  const {
    user_first_name,
    user_last_name,
    user_email,
    user_phone_nbr,
    addr_street1,
    addr_type_id,
    addr_street2,
    addr_zipcode,
    user_id,
    user_typ_id,
    user_allow_wup_sms_yn,
    user_allow_sms_yn,
    user_photo_1,
    role_id,
    user_has_profile_yn,
    user_title_id,
    user_title_cd,
    referer,
    svc_provider_yn
  } = userData || profileData; // Use userData if available, fallback to profileData

  const contryId = profileData.iso_cntry_id || userData?.iso_cntry_id;

  useEffect(() => {
    if (contryId) {
      dispatch(citylist(contryId));
    }
  }, [dispatch, contryId]);

  //console.log(userData);
  const handleCountryChange = (event, setFieldValue) => {
    const newSelectedCountryId = event.target.value;

    setSelectedCountryId(newSelectedCountryId);
    dispatch(citylist(newSelectedCountryId));
    setFieldValue("iso_cntry_id", newSelectedCountryId);
  };

  const handleTitleChange = (event, setFieldValue) => {
    const newSelectedTitleId = event.target.value;
    setFieldValue("user_title_id", newSelectedTitleId);
  };

  const handleCityChange = (selectedOption, setFieldValue) => {
    const selectedCityId = selectedOption ? selectedOption.value : "";
    setSelectedCityId(selectedCityId);
    setFieldValue("iso_city_id", selectedCityId);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => { };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleImageClick = () => {
    document.getElementById("fileInput").click();
  };

  const cityOptions = citiesName.map((city) => ({
    value: city.iso_city_id,
    label: city.iso_city_name,
  }));

  return (
    <div className="flex flex-col">
      <Header pageTitle="User Profile" icon={<ProfileIcon />} />
      <div className="card_white_box bg-gray-500">
        <h5 className="globale-title flex justify-between">
          <span>User Profile</span>
        </h5>

        <Formik
          initialValues={{
            user_id: user_id || "",
            user_title_id: user_title_id || "",
            user_typ_id: user_typ_id || "",
            user_first_name: user_first_name || "",
            user_last_name: user_last_name || "",
            user_email: user_email || "",
            user_phone_nbr: user_phone_nbr || "",
            addr_street1: addr_street1 || "",
            addr_street2: addr_street2 || "",
            addr_zipcode: addr_zipcode || "",
            addr_id: "1",
            iso_cntry_id: contryId || "",
            iso_city_id: userData?.iso_city_id || "",
            addr_state: userData?.iso_city_id || "",
            addr_type_id: addr_type_id || "",
            user_allow_sms_yn: user_allow_sms_yn || "N",
            user_allow_wup_sms_yn: user_allow_wup_sms_yn || "N",
            role_id: role_id || "",
            sys_user_id: user_profile_id || "",
            referer: referer || "", // Add the referrer field here
            svc_provider_yn: svc_provider_yn || "N"
          }}
          onSubmit={(values) => {
            setIsLoading(true); // Set loading state to true on submit
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
            });
            if (selectedImage) {
              formData.append("picture", selectedImage);
            }
            dispatch(editUser(formData, values.user_id))
              .catch((error) => {
                // Handle errors here
                console.error(error);
              })
              .finally(() => {
                setIsLoading(false); // Reset loading state after submission
                history.push({
                  pathname: "/dashboard/users",
                });
              });
          }}
          validationSchema={profileform}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit} className="px-14 mb-7">
              <Row>
                <Col className="mb-3 flex justify-center">
                  <label
                    htmlFor="fileInput"
                    className="image_up mb-2 !rounded-md !h-20"
                    onClick={handleImageClick}
                  >
                    {selectedImage || user_photo_1 ? (
                      <div className="image-preview !items-center">
                        <img
                          src={
                            selectedImage
                              ? URL.createObjectURL(selectedImage)
                              : `${user_photo_1}`
                          }
                          alt="Preview"
                        />
                      </div>
                    ) : (
                      <div className="open_upload">
                        <Icon icon="line-md:upload-loop" className="mx-auto" />
                        <p>Upload Image</p>
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      id="fileInput"
                      style={{ display: "none" }}
                      onChange={handleImageChange}
                      name="svcf_photo"
                    />
                  </label>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Select
                      className="form-control"
                      name="user_title_id"
                      aria-label="default is Mr."
                      onChange={(e) => handleTitleChange(e, setFieldValue)}
                      value={values.user_title_id}
                    >
                      <option value="">{"Select user title"}</option>
                      {titlename.map((item, index) => (
                        <option key={index} value={item.user_title_id}>
                          {item.user_title_cd}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage name="user_title_id" component={Texterror} />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Field
                      className={`form-control ${touched.user_first_name && errors.user_first_name ? "is-invalid" : ""}`}
                      name="user_first_name"
                      type="input"
                      value={values.user_first_name}
                    />
                    <ErrorMessage name="user_first_name" component={Texterror} />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Field
                      className={`form-control ${touched.user_last_name && errors.user_last_name ? "is-invalid" : ""}`}
                      name="user_last_name"
                      type="input"
                      value={values.user_last_name}
                    />
                    <ErrorMessage name="user_last_name" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Field
                      className={`form-control ${touched.user_email && errors.user_email ? "is-invalid" : ""}`}
                      name="user_email"
                      type="input"
                      value={values.user_email}
                    />
                    <ErrorMessage name="user_email" component={Texterror} />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <PhoneInput
                      country={"us"}
                      value={values.user_phone_nbr}
                      onChange={(phone) => setFieldValue("user_phone_nbr", phone)}
                    />
                    <ErrorMessage name="user_phone_nbr" component={Texterror} />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3">
                    <Form.Label>Street 1</Form.Label>
                    <Field
                      className={`form-control ${touched.addr_street1 && errors.addr_street1 ? "is-invalid" : ""}`}
                      name="addr_street1"
                      type="input"
                      value={values.addr_street1}
                    />
                    <ErrorMessage name="addr_street1" component={Texterror} />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3">
                    <Form.Label>Street 2</Form.Label>
                    <Field
                      className={`form-control ${touched.addr_street2 && errors.addr_street2 ? "is-invalid" : ""}`}
                      name="addr_street2"
                      type="input"
                      value={values.addr_street2}
                    />
                    <ErrorMessage name="addr_street2" component={Texterror} />
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <Form.Select
                      name="iso_cntry_id"
                      className="form-control"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                      value={values.iso_cntry_id}
                    >
                      <option value="">{"Select country"}</option>
                      {countryname.map((item, index) => (
                        <option key={index} value={item.iso_cntry_id}>
                          {item.iso_cntry_name}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage name="iso_cntry_id" component={Texterror} />
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mb-3 position-relative">
                    <Form.Label>City</Form.Label>
                    <Select
                      id="searchCity"
                      className="form-control"
                      name="iso_city_id"
                      options={cityOptions}
                      onChange={(selectedOption) => handleCityChange(selectedOption, setFieldValue)}
                      value={cityOptions.find(option => option.value === values.iso_city_id)}
                    />
                    <ErrorMessage name="iso_city_id" component={Texterror} />
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>Zip Code</Form.Label>
                    <Field
                      className={`form-control ${touched.addr_zipcode && errors.addr_zipcode ? "is-invalid" : ""}`}
                      name="addr_zipcode"
                      type="input"
                      value={values.addr_zipcode}
                    />
                    <ErrorMessage name="addr_zipcode" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>

                <Col lg={4}>
                  <div className="mb-3">
                    <Form.Label>Referrer</Form.Label>
                    <Field
                      className={`form-control ${touched.referer && errors.referer ? "is-invalid" : ""}`}
                      name="referer"
                      type="input"
                      value={values.referer}
                    />
                    <ErrorMessage name="referer" component={Texterror} />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="flex items-center gap-2 mb-2">

                    {touched.user_allow_wup_sms_yn &&
                      errors.user_allow_wup_sms_yn && (
                        <div className="invalid-feedback">
                          {errors.user_allow_wup_sms_yn}
                        </div>
                      )}
                  </div>
                  <div className="mini_edit flex justify-start gap-3 mt-3">
                    <button
                      type="submit"
                      className="py-2 px-[14px] text-[13px] font-semibold bg-[#3973B7] text-white !rounded-md w-32 hover:opacity-80"
                    >
                      Submit
                    </button>
                  </div>
                </Col>
              </Row>

            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default withRouter(UserProfile);
